function Downloading() {

  return (
    <div id='downloading-screen' className="loading">
      <h1>Loading replay...</h1>
      Downloading file from the database.
    </div>
  );
}

export default Downloading;